import createActionType from "../../utils/createActionType";

export const MODULE = "stocktake/searchFilter";

export const SET_SEARCH = createActionType(MODULE, "setSearch");

export const RESET = createActionType(MODULE, "reset");
